import { SUPPORTED_LANGUAGES } from "@repo/shared";
import { queryOptions, useQuery, useSuspenseQuery } from "@tanstack/react-query";

import { ApiClient } from "../api-client";

import type { GetCourseResponse } from "../generated-api";
import type { SupportedLanguages } from "@repo/shared";

export const getCourseQueryKey = (id: string, language?: SupportedLanguages) => [
  "course",
  { id, ...(language ? { language } : {}) },
];

export const courseQueryOptions = (idOrSlug: string, language?: SupportedLanguages) =>
  queryOptions({
    queryKey: getCourseQueryKey(idOrSlug, language),
    // Igual que Mi Aula: la ficha del curso se vuelve a pedir al entrar, porque el avance
    // dentro de una clase no invalida nada (ver `useStudentCourses`).
    refetchOnMount: "always" as const,
    queryFn: async () => {
      const response = await ApiClient.api.courseControllerGetCourse({
        id: idOrSlug ?? "",
        language,
      });
      return response.data;
    },
    select: (data: GetCourseResponse) => data.data,
  });

export function useCourse(idOrSlug: string, language: SupportedLanguages = SUPPORTED_LANGUAGES.ES) {
  return useQuery(courseQueryOptions(idOrSlug, language));
}

export function useCourseSuspense(
  idOrSlug: string,
  language: SupportedLanguages = SUPPORTED_LANGUAGES.ES,
) {
  return useSuspenseQuery(courseQueryOptions(idOrSlug, language));
}
